import styled from 'styled-components'
import { anatomyCompact } from '~/pages/anatomy/libs/responsive'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

export const ImageLayoutStyles = {
  Root: styled.div`
    width: 100%;
    height: calc(100dvh - var(--header-height));
    overflow: hidden;

    &:before {
      position: absolute;
      z-index: -1;
      inset: 0;
      content: '';
      background-color: ${COLORS.GRAY_100};
    }

    ${anatomyCompact} {
      overflow-y: auto;
    }
  `,

  StyledContainer: styled(Container)`
    padding: 24px 16px;
    display: flex;
    flex-direction: column;
    height: 100%;
  `,

  Question: styled.h1`
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
    color: ${COLORS.BLACK};
    margin-bottom: 16px;
  `,

  ImageWrapper: styled.div`
    width: 100%;
    border-radius: 16px;
    margin-bottom: 16px;

    img {
      width: 100%;
      display: block;
    }
  `,

  ButtonWrapper: styled.div`
    display: flex;
    width: 100%;
    gap: 14px;
    margin-top: auto;
  `,
} as const
